import moment from 'moment';

export default function genererDataSelect() {
  const dateIn7Days = new Date();
  dateIn7Days.setDate(new Date().getDate() + 7);
  return moment(dateIn7Days).startOf('week').toDate();
}
